import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModalTitle, { withModalSx, modalCancelButtonSx } from "server/components/Modals/ModalTitle";

const EmailPreviewModal = ({ open, onClose, htmlContent, loading }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      sx={withModalSx()}
    >
      <ModalTitle
        icon={<VisibilityIcon />}
        title="Преглед на Имейл"
      />
      <DialogContent
        dividers
        sx={{ p: 0 }}
      >
        {loading ? (
          <Box sx={{ m: "auto", py: 6, display: "flex", alignItems: "center", gap: 2 }}>
            <CircularProgress size={150} />
          </Box>
        ) : (
          <iframe
            title="Email Preview"
            style={{ width: "100%", border: "none", minHeight: 600 }}
            srcDoc={htmlContent || ""}
            sandbox="allow-popups"
          />
        )}
      </DialogContent>

      <DialogActions sx={{ display: "flex", justifyContent: "start", p: 3 }}>
        <Button
          onClick={onClose}
          size="medium"
          color="error"
          variant="outlined"
          startIcon={<CloseIcon />}
          sx={modalCancelButtonSx}
        >
          Отказ
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailPreviewModal;
